module.exports = __webpack_public_path__ + "img/netherlands.67a6d920.png";